module.exports = __webpack_public_path__ + "img/guide-student9.e6f0dd6d.png";